export const localFAQs = [
  {
    question: "whatIsTheRingTwicePlusFormula",
    answer: "whatIsTheRingTwicePlusFormulaAnswer",
    paths: ["chooseFormula", "choosePlan"],
  },
  {
    question: "howToStopRenewal",
    answer: "howToStopRenewalAnswer",
    paths: ["choosePlan", "subscribe"],
  },
  {
    question: "howToChangeSubscription",
    answer: "howToChangeSubscriptionAnswer",
    paths: ["choosePlan"],
  },
  {
    question: "whatAreTheAvailablePaymentMethods",
    answer: "whatAreTheAvailablePaymentMethodsAnswer",
    paths: ["subscribe"],
  },
  {
    question: "canIBeReimbursed",
    answer: "canIBeReimbursedAnswer",
    paths: ["subscribe"],
  },
  {
    question: "howAndWhenToPayService",
    answer: "howAndWhenToPayServiceAnswer",
    paths: ["subscribe", "serviceFee"],
  },
  {
    question: "canIPayCash",
    answer: "canIPayCashAnswer",
    paths: ["serviceFee"],
  },
  {
    question: "whyPayFeesToRingTwice",
    answer: "whyPayFeesToRingTwiceAnswer",
    paths: ["serviceFee"],
  },
  {
    question: "whatDoesTheStandardFormulaConsistOf",
    answer: "whatDoesTheStandardFormulaConsistOfAnswer",
    paths: ["chooseFormula"],
  },
  {
    question: "whyIsRingTwicePaid",
    answer: "whyIsRingTwicePaidAnswer",
    paths: ["chooseFormula"],
  },
  {
    question: "isThePriceOfThePackageIncludedInMyServiceProviderOffer",
    answer: "isThePriceOfThePackageIncludedInMyServiceProviderOfferAnswer",
    paths: ["chooseFormula"],
  },
  {
    question: "howDoIChooseTheFormulaINeed",
    answer: "howDoIChooseTheFormulaINeedAnswer",
    paths: ["chooseFormula"],
  },
  //
  {
    question: "howToPayForTheService",
    answer: "howToPayForTheServiceAnswer",
    paths: ["close"],
  },
  {
    question: "willIReceiveAnInvoice",
    answer: "willIReceiveAnInvoiceAnswer",
    paths: ["close"],
  },
  {
    question: "whatIfIDoNotAgreeWithTheRequestedAmount",
    answer: "whatIfIDoNotAgreeWithTheRequestedAmountAnswer",
    paths: ["close"],
  },
  {
    question: "whyPayManagementFeesToRingTwice",
    answer: "whyPayManagementFeesToRingTwiceAnswer",
    paths: ["close"],
  },
  {
    question: "howCanIWorkWithThisServiceProviderAgain",
    answer: "howCanIWorkWithThisServiceProviderAgainAnswer",
    paths: ["close"],
  },
  {
    question: "whatDoesRingTwicePlusEntail",
    answer: "whatDoesRingTwicePlusEntailAnswer",
    paths: ["close"],
  },
  //
  {
    question: "howToChooseServiceProviderForMyTask",
    answer: "howToChooseServiceProviderForMyTaskAnswer",
    paths: ["service_requests"],
  },
  {
    question: "howToAddPicturesToMyTask",
    answer: "howToAddPicturesToMyTaskAnswer",
    paths: ["service_requests"],
  },
  {
    question: "howToDiscussWithServiceProviderThatReacted",
    answer: "howToDiscussWithServiceProviderThatReactedAnswer",
    paths: ["service_requests"],
  },
  {
    question: "howToModifyMyRequest",
    answer: "howToModifyMyRequestAnswer",
    paths: ["service_requests"],
  },
  {
    question: "whenDoesAServiceStartAndEnd",
    answer: "whenDoesAServiceStartAndEndAnswer",
    paths: ["service_requests"],
  },
  {
    question: "whatDoesProBadgeMean",
    answer: "whatDoesProBadgeMeanAnswer",
    paths: ["service_requests"],
  },
];
